import React, { useEffect, useState } from "react";
import dataBox from "../assets/fake-data/data-box";
import dataFaqs from "../assets/fake-data/data-faq";
import dataPortfolio from "../assets/fake-data/data-portfolio";
import dataProject from "../assets/fake-data/dataProject";
import About from "../components/about/About";
import Banner from "../components/banner/Banner";
import Create from "../components/create/Create";
import Faqs from "../components/faqs/Faqs";
import Footer from "../components/footer/Footer";
import Portfolio from "../components/portfolio/Portfolio";
import Project from "../components/project/Project";
import Speciality from "../components/speciality/Speciality";
import Header from "../components/header/Header";
import logo from "../assets/images/logo/logo.png";

function Home01(props) {
  const [loading, setIsloading] = useState(true);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsloading(false);
      setTransitioning(true); // Trigger logo animation
      setTimeout(() => setTransitioning(false), 2000); // Complete transition after animation
    }, 3000); // Loading duration

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* {loading == false ? (
        <>
          <Header />
          <div className="home-1 wrapper">
            <Banner />

            <About />

            <Speciality data={dataBox} />

            <Portfolio data={dataPortfolio} />

            <Project data={dataProject} />

            <Roadmap data={dataRoadMap} />

            <Team data={dataTeam} />


            <Faqs data={dataFaqs} />

            <Create />

            <Footer />
          </div>
        </>
      ) : (
        <>
          <div
            className="h-screen flex flex-col justify-center items-center"
            style={{
              background: " rgb(21,21,64)",
              background:
                "linear-gradient(90deg, rgba(21,21,64,1) 21%, rgba(2,0,36,1) 50%, rgba(21,21,64,1) 77%)",
            }}
          >
            <div className="">
              <img
                src="https://api.iconify.design/jam:gamepad.svg?color=%23ffffff"
                style={{ height: "50px" }}
                className="imgLogo"
              />
            </div>
            <div class="loading-bar">
              <div class="progress"></div>
            </div>
          </div>
        </>
      )} */}

      <>
        {loading ? (
          <div
            className="h-screen flex flex-col justify-center items-center"
            style={{
              background:
                "linear-gradient(90deg, rgba(21,21,64,1) 21%, rgba(2,0,36,1) 50%, rgba(21,21,64,1) 77%)",
            }}
          >
            <div
              className={`logo-container ${
                transitioning ? "transitioning" : ""
              }`}
            >
              <img
                src={logo}
                style={{ height: "100px" }}
                className={`imgLogo ${transitioning ? "move-to-header" : ""}`}
                alt="Logo"
              />
            </div>
            <div className="loading-bar">
              <div className="progress"></div>
            </div>
          </div>
        ) : (
          <>
            <Header logoTransitioning={transitioning} />
            <div className="home-1 wrapper">
              <Banner />
              <About />
              <Speciality data={dataBox} />
              <Portfolio data={dataPortfolio} />
              <Project data={dataProject} />
              {/* <Roadmap data={dataRoadMap} /> */}
              {/* <Team data={dataTeam} /> */}
              <Faqs data={dataFaqs} />
              <Create />
              <Footer />
            </div>
          </>
        )}
      </>
    </>
  );
}

export default Home01;
